import React from 'react'

function EngagementIcon({ className, ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M18.1001 9C20.3501 10.5 19.3501 14 17.9167 15.6779L18.9659 19.356C18.9927 19.45 18.9689 19.5434 18.8714 19.5471C18.5744 19.5581 17.635 19.345 14.6834 17.7541C12.3501 19 9.35009 19 8.35009 17.5"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6435 4.75C12.3519 4.75004 13.7043 5.26961 14.6659 6.1416C15.6226 7.00913 16.1377 8.17575 16.2645 9.37402C16.5151 11.7406 15.255 14.3808 12.6601 15.3291C10.7995 16.0089 9.08576 15.5602 8.35439 15.3486L6.25185 16.5098C5.23877 17.0685 4.07522 16.0692 4.47451 14.9834L5.00674 13.5342C3.84293 12.2214 3.61409 10.1382 4.34853 8.37793C5.19104 6.35888 7.27257 4.75 10.6435 4.75Z"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default EngagementIcon